import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

const gridStyles = ({ theme }) => css`
  label: new-faq-list__grid;

  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: ${theme.spacings.mega};

  ${theme.media.kilo} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${theme.media.mega} {
    grid-template-columns: repeat(3, 1fr);
  }
`

const categoryLinkStyles = () => css`
  label: new-faq-list__category-link;

  display: block;

  color: inherit;
  text-decoration: none;

  div[class*='card'] {
    height: 100%;
  }

  div[class*='card__body'] {
    text-align: center;
  }

  svg[class*='icon--size-giga'] {
    width: 48px;
    height: 48px;
  }
`

export const Grid = styled('div')(gridStyles)
export const CategoryLink = styled(Link)(categoryLinkStyles)
